import axios from 'axios';

function RefreshFormieToken({ node }) {
	// Fetch the form we want to deal with
	let $form = node.querySelector(`#${node.dataset.id}`);

	// Find the CSRF token hidden input, so we can replace it
	let $csrfInput = $form.querySelector('input[name="CRAFT_CSRF_TOKEN"]');

	// Fetch the new token for the form and replace the CSRF input with our new one
	axios
		.get(`/actions/formie/forms/refresh-tokens?form=${node.dataset.handle}`)
		.then(({ data: result }) => {
			$csrfInput.value = result.csrf.token;

			// Find the JavaScript captcha hidden input, so we can update it
			if (result.captchas && result.captchas.javascript) {
				// JavaScript captcha
				const jsCaptcha = result.captchas.javascript;

				$form.querySelector(`input[name="${jsCaptcha.sessionKey}"]`).value =
					jsCaptcha.value;
			}

			// Find the Duplicate captcha hidden input, so we can update it
			if (result.captchas && result.captchas.duplicate) {
				// Duplicate captcha
				const duplicateCaptcha = result.captchas.duplicate;

				$form.querySelector(
					`input[name="${duplicateCaptcha.sessionKey}"]`
				).value = duplicateCaptcha.value;
			}

			// Update the form's hash (if using Formie's themed JS)
			if ($form.form && $form.form.formTheme) {
				$form.form.formTheme.updateFormHash();
			}
		});

	return () => {};
}

export default RefreshFormieToken;
